import { TENANT_COM } from 'shared/consts/tenants'
import { SERP_FILTERING } from 'shared/experiments/consts'

import store from 'shared/store'
import { isDesktop, isTablet } from 'shared/utils/deviceClassUtils'
import { isExperimentEnabled } from 'views/assets/scripts/optimizely'
import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts/page'

export const isSerpFilteringExperimentActive = variation => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant, deviceClass } = publicRuntimeConfig?.publicConfig || {}
  const { pageType } = publicRuntimeConfig?.pageProperties || {}

  return (
    pageType === PAGE_TYPE_SEARCH_RESULTS &&
    tenant === TENANT_COM &&
    (isTablet(deviceClass) || isDesktop(deviceClass)) &&
    isExperimentEnabled(SERP_FILTERING) &&
    document.querySelector(
      `[data-experiment="serp-filtering"][data-experiment-variation="${variation}"]`
    )
  )
}
